import WarningMessage from './WarningMessage.component';

export default WarningMessage;
